import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.product;
const productUrl = endpointNames.products.funeral;

// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//get all
const getAllSavingsProducts = async (id) => {
    let response;
    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl +'/'+id +'/packages', config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add
const addSavingsProduct = async (request) => {
    let response;
    await axios.post(baseUrl+'sub/add-savings-product',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const addSavingsProductReverse = async (request) => {
    let response;
    await axios.post(baseUrl+'sub/add-savings-product-reverse',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get product details
const getSavingsProductDetails = async (id) => {
    let response;
    await axios.get(baseUrl+'sub/get-savings-product/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//delete
const deleteSavingsProduct = async (id) => {
    let response;
    await axios.delete(baseUrl+'sub/delete-savings-product/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update
const updateSavingsProduct = async (request) => {
    let response;
    await axios.put(baseUrl+'sub/edit-savings-product',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

export default {
    getSavingsProductDetails,getAllSavingsProducts,addSavingsProduct,updateSavingsProduct,deleteSavingsProduct,
    addSavingsProductReverse
}
